import { DateTime } from 'luxon';
const DAY_MS = 86400000;
const dateKeyFormatters = new Map();
function dateKeyFormatter(timeZone) {
    let formatter = dateKeyFormatters.get(timeZone);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat('en-US', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' });
        dateKeyFormatters.set(timeZone, formatter);
    }
    return formatter;
}
export function toCalendarDateKey(date, timeZone) {
    const parts = Object.fromEntries(dateKeyFormatter(timeZone)
        .formatToParts(date)
        .map(({ type, value }) => [type, value]));
    return `${parts.year}-${parts.month}-${parts.day}`;
}
export function addDaysToDateKey(dateKey, days) {
    return new Date(Date.parse(dateKey) + days * DAY_MS).toISOString().slice(0, 10);
}
export function daysBetweenDateKeys(fromKey, toKey) {
    return Math.round((Date.parse(toKey) - Date.parse(fromKey)) / DAY_MS);
}
export function startOfCalendarDay(dateKey, timeZone) {
    return DateTime.fromISO(dateKey, { zone: timeZone }).toJSDate();
}
/** Moves an instant by whole calendar days in `timeZone`, keeping its wall-clock time. */
export function shiftByCalendarDays(date, days, timeZone) {
    return DateTime.fromJSDate(date, { zone: timeZone }).plus({ days }).toJSDate();
}
